/**
 * sl-728o.3.1: Input Fields Session
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createInputFieldsSession(t: I18n): TutorialSession {
  return {
    id: 'automation:inputFields',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'input',
    },
    steps: [
      {
        targetSelector: '[data-coachmark-target="fields-column-list"]',
        title: t['com.streamlain.streamlain.coach.fields-select.title'](),
        content: t['com.streamlain.streamlain.coach.fields-select.content'](),
        animation: 'pulse',
      },
      {
        targetSelector:
          '[data-coachmark-target="fields-column-list"] > div:first-child',
        title: t['com.streamlain.streamlain.coach.fields-toggle.title'](),
        content: t['com.streamlain.streamlain.coach.fields-toggle.content'](),
        animation: 'highlight',
        onEnter: () => {
          const firstRow = document.querySelector(
            '[data-coachmark-target="fields-column-list"] > div:first-child'
          ) as HTMLElement | null;
          firstRow?.click();
        },
        delay: 150,
      },
      {
        targetSelector: '[data-coachmark-target="fields-select-all"]',
        title: t['com.streamlain.streamlain.coach.fields-all.title'](),
        content: t['com.streamlain.streamlain.coach.fields-all.content'](),
        animation: 'highlight',
      },
    ],
  };
}
